<template>
    <div class="uiSample">
        <h1>Sample Component</h1>
        <span>{{ message }}</span>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'SampleComponent',
    props: {
        message: String,
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.uiSample {
    background-color: white;
}
</style>
